<script setup>
import { computed, ref, watch } from 'vue';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { useMapGetter } from 'dashboard/composables/store';
const props = defineProps({ usage: { type: Object, default: null } });
const { isAdmin } = useAdmin();
const accountId = useMapGetter('getCurrentAccountId');
const receiptAccountId = ref(null);
watch(
  () => props.usage,
  usage => {
    receiptAccountId.value = usage ? accountId.value : null;
  },
  { immediate: true, flush: 'sync' }
);
watch(
  accountId,
  () => {
    receiptAccountId.value = null;
  },
  { flush: 'sync' }
);
const canViewReceipt = computed(
  () =>
    isAdmin.value &&
    Number(accountId.value) > 0 &&
    receiptAccountId.value === accountId.value
);
const tokens = computed(() =>
  Number(props.usage?.total_tokens || 0).toLocaleString('pt-BR')
);
const cost = computed(() =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  }).format(props.usage?.estimated_cost_brl || 0)
);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template -->
  <div
    v-if="usage && canViewReceipt"
    class="rounded-lg border border-n-weak bg-n-solid-2 px-3 py-2 text-xs text-n-slate-11 space-y-1"
    role="status"
  >
    <p class="m-0">
      <span v-if="usage.token_usage_available">{{ tokens }} tokens</span>
      <span v-else>Tokens não informados pelo provedor</span>
      <span aria-hidden="true"> · </span>
      <span v-if="usage.priced">Custo estimado: {{ cost }}</span>
      <span v-else>Custo indisponível para esta ação</span>
    </p>
    <p v-if="usage.credential_source" class="m-0">
      {{
        usage.credential_source === 'account'
          ? 'OpenAI da empresa'
          : `${usage.credits || 0} créditos IA utilizados`
      }}
    </p>
    <p v-if="usage.credits_refunded" class="m-0">
      {{ usage.credits_refunded }} créditos IA devolvidos.
    </p>
    <details v-if="usage.token_usage_available" class="text-xs">
      <summary class="cursor-pointer">Detalhes do consumo</summary>
      <p class="m-0">
        Entrada: {{ usage.input_tokens }} · Saída: {{ usage.output_tokens }} ·
        {{ usage.model }}
      </p>
      <p v-if="usage.priced" class="m-0">
        Estimativa em dólares: {{ usage.estimated_cost_usd }} · Cotação
        utilizada: R$ {{ usage.usd_brl_rate }}. O custo estimado da OpenAI é
        diferente do saldo de créditos.
      </p>
    </details>
  </div>
</template>
